import React, { useState, useRef } from "react";
import AdminBackNavigation from "../../../components/CommonComponents/AdminBackNavigation";
import { useNavigate } from "react-router-dom";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import { useMyContext } from "../../../components/Provider/CommonProvider";
import AdminImageUploadZone from "../../../components/CommonComponents/AdminImageUploadZone";
import { IoMdInformationCircle } from "react-icons/io";
import axios from "axios";
import Select from "react-select";
import { useEffect } from "react";

function AddManageAge({ isModal = false, onSuccess, setApiresponsealert, setShowalert }) {

  const { fetchRequest, globalImageUplaodAPI } = useMyContext();

  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [id, setId] = useState("");
  const [slug, setSlug] = useState("");
  const [age, setAge] = useState("");
  const [active, setActive] = useState("");
  const [ratingLogo, setRatingLogo] = useState(null);
  const [logoPreview, setLogoPreview] = useState(null);

  const access_token = localStorage.getItem("access_token");

  const [editUser, setEditUser] = useState({
    age: "",
  });

  const handleInput = (e) => {
    const { name, value } = e.target;
    setEditUser((prevEditUser) => ({
      ...prevEditUser,
      [name]: value,
    }));

    setValidationMessageage("");
    setIsValidationHiddenage(true);

    setEditUser({ ...editUser, title: e.target.value });
    setEditUser({ ...editUser, [e.target.name]: e.target.value });

    if (e.target.checked === true) {
      setActive({ ...active, [e.target.name]: 1 });
    } else {
      setActive({ ...active, [e.target.name]: 0 });
    }
  };


  const handleInputenable = (e) => {
    if (e.target.checked === true) {
      setEditUser({ ...editUser, [e.target.name]: 1 });
    } else {
      setEditUser({ ...editUser, [e.target.name]: 0 });
    }
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setRatingLogo(file);
      setLogoPreview(URL.createObjectURL(file));
    }
  };

  const handleClearFile = () => {
    setRatingLogo(null);
    setLogoPreview(null);
  };

  const [validationMessageage, setValidationMessageage] = useState("");
  const [isValidationHiddenage, setIsValidationHiddenage] = useState(true);

  const ageInputRef = useRef(null);

  const [processing, setProcessing] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);

  async function saveage() {
    let focusInputRef = null;
    const trimmedAddAge = editUser?.age?.trim();

    if (trimmedAddAge === "") {
      setValidationMessageage("Age cannot be empty.");
      setIsValidationHiddenage(false);
      focusInputRef = ageInputRef;
    }

    if (focusInputRef) {
      focusInputRef.current.focus();
      return;
    }

    const aactivedatadata = Number.isNaN(parseInt(aactivedata, 10)) ? 0 : parseInt(aactivedata, 10);
    const editInputvalue = active.active;
    var data = JSON.stringify(editInputvalue);
    var aactivedata = data;

    const formData = {
      id: editUser?.id,
      age: editUser?.age,
      slug: editUser?.slug,
      active: editUser?.active,
    };


    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + access_token,
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
    };

    let firstApiStatus = false;
    let resultapi = null;

    setProcessing(true);
    setShowOverlay(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_Baseurl}/admin/age-category/store`, formData, { headers: headers }
      );

      resultapi = response.data;

      if (resultapi.status === true) {
        firstApiStatus = true;
        // If a logo is selected, upload it
        if (ratingLogo) {
          const imageFormData = new FormData();
          imageFormData.append('modelName', 'AgeCategory');
          imageFormData.append('id', resultapi.Age_Category.id);
          imageFormData.append('imageFields[]', 'rating_logo');
          imageFormData.append('rating_logo', ratingLogo);

          await fetchRequest({
            method: 'POST',
            url: globalImageUplaodAPI(),
            data: imageFormData,
          });
        }
        toast.success(resultapi.message);
      } else {
        toast.error(resultapi.message || "Failed to save age category.");
      }
    } catch (error) {
      const apiError =
        error?.response?.data?.message || error?.message || "An unexpected error occurred.";
      toast.error(apiError); // Show only API error message
    }

    if (firstApiStatus) {
      setValidationMessageage("");
      if (typeof setApiresponsealert === 'function') setApiresponsealert(resultapi);
      if (typeof setShowalert === 'function') setShowalert(true);

      if (typeof onSuccess === 'function' && isModal) {
        onSuccess(editUser?.age);
      } else {
        setTimeout(() => {
          navigate("/age/index");
        }, 3000);
      }
    } else {
      if (resultapi && resultapi.status === false) {
        if (typeof setApiresponsealert === 'function') setApiresponsealert(resultapi);
        setIsValidationHiddenage(true);
      }
    }

    setProcessing(false);
    setShowOverlay(false);
  }

  return (
    <>

      <div className=" m-0 p-0">
        <div className="">
          <section className="container-fluid">
            <div className="col-lg-12 row py-3">
              <div className="col-6 col-sm-6 col-lg-6">
                <h3>Add Age Category</h3>
              </div>
              <div className="col-6 col-sm-6 col-lg-6">
                <div className="text-end">
                  <button onClick={saveage} className="button-bg-color theme-button-text-color admin-button-text rounded-3 py-2 px-3">
                    Save Age
                  </button>
                </div>
              </div>
            </div>

            <div>
              {showOverlay && <Response_Processing></Response_Processing>}
              {!isModal && <AdminBackNavigation path="/age/index" text="Back" />}
            </div>
            <div className="row col-lg-12 ">
              <div className=" col-sm-6 col-md-6 col-lg-6 ">
                <div className="card p-3">
                  <h5 className="theme-text-color theme-border-secondary-color pb-3 mb-3 mt-0">Create Age</h5>
                  <div className=" text-start">
                    <label className="m-0">
                      <p className="mandatorySimple theme-text-color mt-0 admin-input-title d-block position-relative">Age</p>
                    </label>
                    <div className="mt-2">
                      <input type="text" className={`custom-input custom-input-border w-100 custom-placeholder bg-transparent  theme-text-color mb-3 ${!isValidationHiddenage && 'custom-input-error'} `} id="age" name="age" onChange={handleInput} value={editUser?.age} ref={ageInputRef} />
                    </div>
                    {!isValidationHiddenage && (<div className='d-flex align-items-center gap-1 mb-2'><IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} /><MessageBox text={`${validationMessageage}`} classname='errorred  d-block' /></div>)}
                  </div>

                  <div className="text-start mt-3">
                    <MessageLabel text="Rating Logo" />
                    <AdminImageUploadZone
                      onChange={handleFileChange}
                      selectedFile={ratingLogo}
                      uploadedImage={logoPreview}
                      onDelete={handleClearFile}
                      name="rating_logo"
                      id={editUser?.id}
                      idAttribute="rating_logo"
                    />
                  </div>
                </div>
              </div>

              {/* Second Part of Section  */}

              <div className=" col-sm-6 col-md-6 col-lg-6">
                <div className="card p-3">
                  <h5 className="theme-text-color theme-border-secondary-color pb-3 mb-3 mt-0">Status Setting</h5>
                  <div className="panel panel-primary" data-collapsed="0">
                    <div className="panel-body d-flex justify-content-between">
                      <div className="col-6 col-md-6 ps-2">
                        <MessageLabel text={"Status"} />
                      </div>
                      <div className="col-6 col-md-6 ps-2 text-end">
                        <AdminSwitch name="active" checked={editUser?.active == 1} onChange={(e) => handleInputenable(e, editUser)} id={editUser?.active} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}

export default AddManageAge;
